// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5c6fa25d","488":"1f961d12"}[chunkId] + ".chunk.js";
};